import { Category } from './category';
import { Unit } from './unit';
import { Group } from './group';
import { Faction } from './faction';
import { Import } from './import';
import { Genus } from './genus';
import { Club } from './club';

export class Root {
    public content: Genus = new Genus(undefined);
    public aspect: Faction = new Faction(undefined);
    public type: Category = new Category(undefined);
    public user: Group = new Group(undefined);
    public role: Unit = new Unit(undefined);
    public client: Club = new Club(undefined);
    public import: Import = new Import('Import');

    constructor(source?: any) {
        if (source) {
            const { content, aspect, type, user, role, client, realm, syndicate } = source;
            if (content) {
                this.content.load(content);
            }
            if (aspect) {
                this.aspect.load(aspect);
            }
            if (type) {
                this.type.load(type);
            }
            if (user) {
                this.user.load(user);
            }
            if (role) {
                this.role.load(role);
            }
            if (client) {
                this.client.load(client);
            }
            if (realm && syndicate) {
                this.import.loadChildren(realm, syndicate);
            }
        }
    }
}
